import { render, staticRenderFns } from "./FormFornecedorPersonalInfo.vue?vue&type=template&id=0c61670f"
import script from "./FormFornecedorPersonalInfo.vue?vue&type=script&lang=js"
export * from "./FormFornecedorPersonalInfo.vue?vue&type=script&lang=js"
import style0 from "./FormFornecedorPersonalInfo.vue?vue&type=style&index=0&id=0c61670f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports